import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const PortfolioEditForm = lazy(
  () => import('@components/Group/Portfolio/PortfolioEditForm')
);

/** 포트폴리오사 > 수정하기 */
const PortfolioEdit = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <PortfolioEditForm />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default PortfolioEdit;
